export interface AccountGroupOption {
  account_group_id: number;
  label: string;
}

/** account_group_id for a specific account from session `accounts`. */
export function getAccountGroupIdForAccount(
  accountId: string | number | null | undefined
): number | null {
  if (accountId == null || accountId === '') {
    return null;
  }

  const raw = sessionStorage.getItem('accounts');
  if (!raw) {
    return null;
  }

  try {
    const accounts = JSON.parse(raw);
    if (!Array.isArray(accounts)) {
      return null;
    }

    const match = accounts.find(
      (a: { account_id?: number | string }) => Number(a.account_id) === Number(accountId)
    );
    const groupId = match?.account_group_id;
    return groupId != null && Number(groupId) > 0 ? Number(groupId) : null;
  } catch {
    return null;
  }
}

/** account_group_id from session `accounts` (current account_id or first approved). */
export function getAccountGroupIdFromSession(): number | null {
  const raw = sessionStorage.getItem('accounts');
  if (!raw) {
    return null;
  }
  try {
    const accounts = JSON.parse(raw);
    if (!Array.isArray(accounts) || accounts.length === 0) {
      return null;
    }

    const sessionAccountId = sessionStorage.getItem('account_id');
    if (sessionAccountId) {
      const current = accounts.find(
        (a: { account_id?: number | string }) => Number(a.account_id) === Number(sessionAccountId)
      );
      const gid = current?.account_group_id;
      if (gid != null && Number(gid) > 0) {
        return Number(gid);
      }
    }

    const preferred = accounts.find((a: { is_approved?: number }) => a.is_approved === 1) ?? accounts[0];
    const groupId = preferred?.account_group_id;
    return groupId != null && Number(groupId) > 0 ? Number(groupId) : null;
  } catch {
    return null;
  }
}

export function getAccountGroupsFromSession(): AccountGroupOption[] {
  const raw = sessionStorage.getItem('accounts');
  if (!raw) {
    return [];
  }
  try {
    const accounts = JSON.parse(raw);
    if (!Array.isArray(accounts)) {
      return [];
    }
    const map = new Map<number, string>();
    for (const a of accounts) {
      const gid = Number(a.account_group_id);
      if (!gid || map.has(gid)) {
        continue;
      }
      const label =
        (a as { account_group_name?: string }).account_group_name ||
        a.account_name ||
        `Company ${gid}`;
      map.set(gid, label);
    }
    return Array.from(map.entries()).map(([account_group_id, label]) => ({
      account_group_id,
      label
    }));
  } catch {
    return [];
  }
}
